import React from 'react';

interface Props {
  title: string;
  subtitle?: React.ReactNode;
}

export default function ListItemText({ title, subtitle }: Props) {
  return (
    <>
      <span className="base-list__item-title">{title}</span>
      {subtitle && <p className="base-list__item-subtitle">{subtitle}</p>}
    </>
  );
}
